import Api from "../../../app/apiRequest";
import BaseResponse from "../../../app/BaseResponse";
import CashDetailQueryModel from "../models/CashDetailQueryModel";
import CashModel from "../models/CashModel";
import CashStatiticModel from "../models/CashStatiticModel";

export interface SearchCashParam {
    pageSize: number,
    query: CashDetailQueryModel
}

export interface GetCashByIdParam {
    id: string,
}

export interface DeleteCashByIdParam {
    id: string,
}

const CashApi = {
    Search(param: SearchCashParam) {
        return Api.post<SearchCashParam, BaseResponse<CashModel[]>>("/api/Cash/Search", param);
    },
    Save(param: CashModel) {
        return Api.post<CashModel, BaseResponse<CashModel>>("/api/Cash/Save", param);
    },
    GetById(param: GetCashByIdParam) {
        return Api.get<GetCashByIdParam, BaseResponse<CashModel>>("/api/Cash/GetById", param);
    },
    Delete(param: DeleteCashByIdParam) {
        return Api.post<DeleteCashByIdParam, BaseResponse<CashModel>>("/api/Cash/Delete", param);
    },
    GetCashStatitics() {
        return Api.get<unknown, BaseResponse<CashStatiticModel[]>>("/api/Cash/GetCashStatitics", null);
    },
};
export default CashApi;